import React from 'react';
import { Typography, Tabs } from 'antd';
import ShipmentPlanTab from '../CRM/tabs/ShipmentPlanTab';
import ServiceScheduleTab from '../CRM/tabs/ServiceScheduleTab';

const { Title, Text } = Typography;

// ══════════════════════════════════════════════
//  企业侧：服务跟踪（出货计划 / 服务排期）
//  出货计划：企业可增删改；服务排期：仅查看
// ══════════════════════════════════════════════

const ServiceTracking = () => {
  const items = [
    {
      key: 'shipment',
      label: '出货计划',
      children: <ShipmentPlanTab mode="enterprise" />,
    },
    {
      key: 'schedule',
      label: '服务排期',
      children: <ServiceScheduleTab mode="enterprise" />,
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 4 }}>
        <Title level={4} style={{ margin: 0 }}>服务跟踪</Title>
        <Text type="secondary" style={{ fontSize: 12 }}>
          出货计划可自行维护，服务排期由平台客服维护，仅供查看
        </Text>
      </div>
      <Tabs items={items} defaultActiveKey="shipment" />
    </div>
  );
};

export default ServiceTracking;
